var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function Svg(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 12,
    viewBox: "0 0 11 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.5625 1.5H6.9375V0.5625C6.9375 0.257812 7.17188 0 7.5 0C7.80469 0 8.0625 0.257812 8.0625 0.5625V1.5H9C9.82031 1.5 10.5 2.17969 10.5 3V10.5C10.5 11.3438 9.82031 12 9 12H1.5C0.65625 12 0 11.3438 0 10.5V3C0 2.17969 0.65625 1.5 1.5 1.5H2.4375V0.5625C2.4375 0.257812 2.67188 0 3 0C3.30469 0 3.5625 0.257812 3.5625 0.5625V1.5ZM1.125 5.8125H3V4.5H1.125V5.8125ZM1.125 6.9375V8.4375H3V6.9375H1.125ZM4.125 6.9375V8.4375H6.375V6.9375H4.125ZM7.5 6.9375V8.4375H9.375V6.9375H7.5ZM9.375 4.5H7.5V5.8125H9.375V4.5ZM9.375 9.5625H7.5V10.875H9C9.1875 10.875 9.375 10.7109 9.375 10.5V9.5625ZM6.375 9.5625H4.125V10.875H6.375V9.5625ZM3 9.5625H1.125V10.5C1.125 10.7109 1.28906 10.875 1.5 10.875H3V9.5625ZM6.375 4.5H4.125V5.8125H6.375V4.5Z",
    fill: "#F92E34"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg);
export default __webpack_public_path__ + "static/media/.2b5c5bc9009231a312857d345d1e097d.svg";
export { ForwardRef as ReactComponent };